// src/hooks/useTranslation.js
import { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

const translations = {
  en: {
    header: {
      title: "UNITED LIMITED COMPANY",
      subtitle: "Best Rental Equipment Services",
      help: "Need Help?",
      contact: "Request a call",
      emergency: "Emergency?",
      login: "Client Portal",
      search: "Search equipment...",
      location: "Saudi Arabia",
    },
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      equipment: "Equipment",
      projects: "Projects",
      ourteam: "Our Team",
      developercrew: "Developer Crew",
      contact: "Contact",
      blog: "Blog",
    },
    hero: {
      slide1: {
        subtitle: "FEATURED PROJECT",
        title: "Premier Equipment Rental and General Contracting Company",
        description:
          "We operate with a fleet of state-of-the-art construction equipment and consistently invest in both the acquisition of cutting-edge heavy machinery and the meticulous maintenance of our existing assets. This ensures optimal performance, safety, and reliability across all our projects",
        button: "View Project",
      },
      slide2: {
        subtitle: "BUILDING THE FUTURE",
        title: "Premier Equipment Rental and General Contracting Company",
        description:
          "United Limited Company is driven by a strategic vision to expand its business and heavy equipment portfolio in line with construction, oil and gas, and industrial market demands. Our primary focus is to support our valued clients during critical operations such as plant shutdowns and maintenance services. ",
        button: "View Project",
      },
      slide3: {
        subtitle: "OUR SERVICES",
        title: "Premier Equipment Rental and General Contracting Company",
        description:
          "We operate with a fleet of state-of-the-art construction equipment and consistently invest in both the acquisition of cutting-edge heavy machinery and the meticulous maintenance of our existing assets. This ensures optimal performance, safety, and reliability across all our projects",
        button: "View Project",
      },
    },
    about: {
      firstpicturetag: "Top Rentals Services",
      secondpicturetag: "Top Contracting Services",

      commonsection: "Premier Equipment Rental and General Contracting Company",
      subtitle: "Get to Know United Limited Company",
      title: "Equipment Rental and General Contracting",
      aboutpagetitle:
        "At United Limited Company, we deliver complete solutions across the equipment rental and general contracting spectrum in Saudi Arabia",

      description:
        "Established in 2024, United Limited Company is a premier rental services and general contracting company in the Kingdom of Saudi Arabia. As a proud subsidiary of the renowned United Equipment Group, United Limited Company is committed to leading the equipment rental, construction, and contracting sector across all major industries, including the demanding oil and gas, infrastructure, and industrial sectors.",

      seconddescription:
        "Our strength lies in a highly skilled team of professional engineers who are dedicated to delivering excellence in construction, heavy equipment rental, and general contracting services. We uphold the highest standards of quality, safety, integrity, and responsiveness, while fostering strong, long-term partnerships with our clients. United Limited Company is deeply committed to honoring every engagement and continuing to serve with distinction across the Kingdom of Saudi Arabia’s construction, oil and gas, infrastructure, and industrial sectors.",
      feature1: "Flexible rental plans",
      feature2: "Experienced and skilled operators",
      feature3: "Licensed and certified",
      feature4: "Reliable and well-maintained machinery",
      feature11: "On-Time Equipment Delivery",
      feature12: "Short-Term & Long-Term Rentals",
      feature13: "Skilled & Licensed Technicians",
      feature14: "Modern, Well-Maintained Fleet",
      experience: "Years Experience",
      imageAlt:
        "Excavator for rent in Saudi Arabia – United Limited Company heavy equipment rental services",
    },
    services: {
      title: "Our Services",
      subtitle: "Specialized solutions for your business needs",
      rental: {
        title: "Rental Services",
        desc: "United Limited Company provides reliable and cost-effective equipment rental solutions for construction machinery, industrial tools, and heavy equipment to support your projects with efficiency and ease. From construction equipment, industrial machinery, and specialized tools to advanced rental options, we ensure well-maintained, ready-to-use rentals that meet your timeline and budget. With flexible rental terms, certified operators, and dedicated customer support, United Limited Company Advanced is your trusted partner for all your rental service needs in Saudi Arabia.",
      },
      contracting: {
        title: "General Contracting Services",
        desc: "United Limited Company is a trusted name in contracting and construction services, delivering high-quality civil engineering, infrastructure development, and maintenance solutions across various sectors. With a commitment to safety, innovation, sustainability, and excellence, we take pride in turning complex challenges into successful projects. Whether it's residential construction, commercial contracting, or industrial projects, United Limited Company is your reliable partner for results that stand the test of time in the Kingdom of Saudi Arabia.",
      },
      learnMore: "Learn More",
    },
    testimonials: {
      subtitle: "Client Feedback",
      title: "What Our Clients Say",
      quote1:
        "The service was absolutely fantastic! They went above and beyond to meet our needs and delivered exceptional results. I would highly recommend them to anyone looking for quality service.",
      role1: "CEO, Ammico",
    },
    projects: {
      title: "Our Project Experience Across Saudi Arabia",
      subtitle: "Our Projects",
      description:
        "View successful projects by United Limited Company across Oil & Gas, construction, plant shutdowns, and infrastructure development in Saudi Arabia.",
      servicesTitle: "Our Services Provided",
      viewButton: "View Project",
      viewAllButton: "View All Projects",
      stats: {
        area: "Area (sqm)",
        floors: "Floors",
        equipment: "Equipment Used",
        length: "Length (km)",
        lanes: "Lanes",
        buildings: "Buildings",
      },
      services: {
        earthworks: "Earthworks & Grading",
        sitePrep: "Site Preparation",
        excavation: "Excavation Services",
        structural: "Structural Construction",
        mep: "MEP Installation",
        roadConstruction: "Road Construction",
        bridge: "Bridge Work",
        landscaping: "Landscaping",
        concrete: "Concrete Work",
        steel: "Steel Erection",
        utilities: "Utility Installation",
      },
      project1: {
        title: "South West Transport Hub Project",
        location: "Lower Qiddiya, Riyadh, KSA",
        description:
          "United Limited Company is proud to lead the transport hub construction in Qiddiya through the South West Transport Hub Project in Riyadh, KSA.As one of the top contracting firms in Riyadh for infrastructure, we specialize in general contracting for transport projects across the Kingdom.Our expert team provides engineering and technical manpower in Saudi Arabia to ensure precision in all phases.We support operations with state-of-the-art equipment rental in Riyadh and a fleet built for intensive infrastructure demands.United Limited Company is a trusted name for reliable machinery rental in Saudi Arabia, ensuring efficient delivery across sectors.We also deliver strategic project support services in KSA, including specialized equipment for the Oil & Gas industry and project support for plant turnarounds.",
      },
      project2: {
        title: "QPAC Project",
        location: "Upper Qiddiya, Riyadh, KSA",
        description:
          "United Limited Company is proud to lead the QPAC project in Upper Qiddiya, advancing national infrastructure goals in KSA.We specialize in turnkey construction in Saudi Arabia, delivering complex projects with compliance and precision.As a leader in large-scale construction in Riyadh, we offer full technical support for infrastructure and project support in Riyadh.Our role in the QPAC project highlights our tailored construction solutions across KSA.With a modern fleet, United Limited Company ensures reliable equipment rental in Qiddiya and heavy equipment services for all phases.Recognized among top contracting firms in Qiddiya, we align with Saudi Arabia’s infrastructure development vision.",
      },
      project3: {
        title: "Al Quds Tower Project",
        location: "Doha, Qatar",
        description:
          "United Limited Company is proud to support the Al Quds Tower Project, a landmark in high-rise construction in Doha and the GCC.As a trusted turnkey contractor in Qatar, we lead all phases of this tower project with structural precision and speed.We provide expert technical manpower in Doha and regionally compliant project management across the GCC.Our role includes advanced equipment rental in Qatar, ensuring reliable machinery and skilled operation on-site.United Limited Company delivers tailored construction solutions in Qatar that meet complex high-rise demands.We continue to drive commercial development in Doha as a preferred name in commercial contracting.",
      },

      project4: {
        title: "Doha Land, Musheireb Project",
        location: "Doha, Qatar",
        description:
          "United Limited Company proudly contributes to the urban development of the Doha Land Musheireb Project, a landmark in central Doha.Selected for expertise in mixed-use contractingacross Qatar, United Limited Company delivers tailored solutions for complex city-scale projects.Our services include advanced project management and engineering manpower in Musheireb and Doha, ensuring efficient execution.We provide reliable equipment rental and skilled operators for vital infrastructure and civil works within the urban core.As a trusted partner for turnkey construction in Qatar, United Limited Company supports sustainable growth in the region.Our role in real estate contracting and strategic urban construction cements our position among top firms in Doha",
      },
      project5: {
        title: "Sheraton Car Park Project ",
        location: "Doha, Qatar",
        description:
          "United Limited Company leads the car park construction of the Sheraton Project in Doha, enhancing urban infrastructure and mobility.We offer turnkey civil works for structured parking, with expertise in design, execution, and public access integration.United Limited Company provides expert engineering manpower and modern systems for reliable and sustainable parking solutions.Backed by advanced fleets, we deliver civil project equipment rental meeting the highest safety and performance standards.Our role strengthens mobility infrastructure and positions United Limited Company among top contracting firms in Doha for public projects.",
      },
    },
    footerr: {
      contactUs: "Connect with us",
      company: {
        name: "United Limited Company",
        tagline: "Company",
        description:
          "Established in 2024, United Limited Company is a premier rental services and general contracting company in the Kingdom of Saudi Arabia. As a proud subsidiary of the renowned United Equipment Group, United Limited Company is committed to leading the equipment rental, construction, and contracting sector across all major industries, including the demanding oil and gas, infrastructure, and industrial sector.",
      },
      quickLinks: {
        title: "Quick Links",
        about: "About",
        privacy: "Privacy Policy",
        carListing: "Car Listing",
        blog: "Blog",
        contact: "Contact",
      },
      contact: {
        title: "Head Office",
        address:
          "8074, Al Sahaba Street, Al Yarmuk District, Riyadh, 13243 Kingdom of Saudi Arabia",
        phone: "+966538077541",
        email: "Ksa@unitedlimited.net",
        hours: "Office Hours: 8am - 10pm",
      },
      newsletter: {
        title: "Newsletter",
        description: "Subscribe for special offers and updates",
        placeholder: "Your Email",
      },
      privacy: "Privacy Policy",
      paymentMethods: "payment methods",

      copyright: "Copyright 2025, United Limited Company. All rights reserved",
      developedBy: "Developed by AI Tech Crew", // نیا اضافہ
      terms: "Terms & Conditions",
    },
    login: {
      welcome: "Welcome to United Limited",
      tagline: "Heavy Equipment & Construction Management Portal",
      feature1: "Project Management",
      feature2: "Equipment Tracking",
      feature3: "Team Collaboration",
      sign_in: "Sign In",
      access_portal: "Access your construction management portal",
      email: "Email Address",
      email_placeholder: "Enter your company email",
      password: "Password",
      password_placeholder: "Enter your password",
      forgot_password: "Forgot Password?",
      signing_in: "Signing In...",
      no_account: "Don't have an account?",
      contact_admin: "Contact your administrator",
      error: "Invalid credentials. Please try again.",
      network_error: "Network error. Please try again later.",
    },
    footer: {
      company: {
        name: "United Limited",
        tagline: "Company",
      },
      quickLinks: {
        privacy: "Privacy Policy",
        contact: "Contact",
      },
      copyright: "Copyright 2025, United Limited Company. All rights reserved",
      terms: "Terms & Conditions",
    },
    contact: {
      contact: "Contact Us | United Limited Company Saudi Arabia",
      sectionTitle: "Get In Touch",
      contactdescription:
        "Contact United Limited Company for equipment rental and contracting services in Saudi Arabia. Get support for Oil & Gas, construction, and infrastructure projects.",
      sectionSubtitle: "Contact United Limited Company",
      formTitle: "Send us a message",
      namePlaceholder: "Your Name",
      emailPlaceholder: "Email Address",
      phonePlaceholder: "Phone Number",
      messagePlaceholder: "Your Message...",
      sendButton: "Send Message",
      infoTitle: "Contact Information",
      infoSubtitle: "Reach out through any of these channels",
      locationTitle: "Our Location",
      phoneTitle: "Phone Number",
      emailTitle: "Email Address",
      hoursTitle: "Working Hours",
      supportText: "Support",
      weekdaysHours: "Saturday - Thursday: 7AM - 5PM",
      weekendHours: "Friday - Saturday: 10AM - 6PM",
      followUs: "Follow Us",
    },
    team: {
      title:
        "Our Engineering & Project Team | United Limited Company Saudi Arabia",
      subtitle: "A Team Built for Performance",
      description:
        "Meet the professional engineers and specialists at United Limited Company who deliver outstanding rental and contracting services in Saudi Arabia.",
      expertiseTitle: "Key Expertise",
      bio: {
        managingDirector:
          "Seasoned engineer with 20+ years in construction leadership...",
        ceo: "Strategic business leader focused on growth and innovation...",
        cmo: "Marketing expert with a track record of successful brand campaigns...",
      },
      members: {
        samir: {
          name: "Eng. Samir Almughanni",
          position: "Managing Director",
        },
        ali: {
          name: "Ali Asfand",
          position: "Chief Executive Officer",
        },
        muhammad: {
          name: "Muhammad Abdullah",
          position: "Chief Marketing Officer",
        },
      },
      expertise: {
        strategy: "Strategic Planning",
        leadership: "Executive Leadership",
        engineering: "Engineering Excellence",
        operations: "Operations Management",
        management: "Business Management",
        finance: "Financial Strategy",
        growth: "Growth Development",
        innovation: "Innovation",
        branding: "Brand Strategy",
        digital: "Digital Marketing",
        communications: "Corporate Communications",
      },
    },

    developerCrew: {
      title: "Developer Crew",
      subtitle: "Innovation Behind Our Operational Growth",
      developerCrewContent:
        "At United Limited Company, our Developer Crew is responsible for business growth, operational efficiency, and portfolio expansion across equipment rental and contracting services. ",
      description:
        "The Developer Crew at United Limited Company drives business and equipment expansion for rental and contracting success across Saudi Arabia.",
      roleSummaryTitle: "Role Summary",
      expertiseTitle: "Core Skills",
      members: {
        muhammad: {
          name: "Muhammad Abdullah",
          position: "Operations & Project Manager",
        },
        sohaib: {
          name: "Sohaib Saleem",
          position: "Developer (Technical Lead)",
        },
        raza: {
          name: "Raza Ali",
          position: "Digital Marketing Executive",
        },
        intern: {
          name: "Ayla Ali Khan (Intern)",
          position: "Marketing & Operations Support",
        },
      },
      roles: {
        muhammad:
          "A highly skilled professional with 6 years of experience in operations, client relations, and project management across multinational companies. As Operations & Project Manager at AI Tech Crew, Muhammad Abdullah leads the team to deliver high-quality IT solutions while ensuring smooth workflows and excellent client experiences. ",
        sohaib:
          "A highly skilled developer with 4 years of professional experience in web and software development. As the Technical Lead at AI Tech Crew, he is responsible for designing, developing, and implementing innovative IT solutions that meet client needs and industry standards.",
        raza: "A result-driven Digital Marketing Executive with 3 years of experience in creating and executing successful online marketing campaigns. At AI Tech Crew, he is responsible for building the company's digital presence, managing client campaigns, and driving leads for business growth.",
        intern:
          "A learning role designed to support the marketing, operations, and project management teams. The intern will assist in daily tasks, gain hands-on experience in the IT services industry, and develop professional skills in digital marketing and business operations.",
      },
      expertise: {
        operations: "Operations Management",
        projectManagement: "Project Management",
        clientRelations: "Client Relations",
        digitalMarketing: "Digital Marketing",
        webDevelopment: "Web Development",
        softwareDevelopment: "Software Development",
        technicalLeadership: "Technical Leadership",
        innovation: "Innovation",
        campaignManagement: "Campaign Management",
        brandBuilding: "Brand Building",
        leadGeneration: "Lead Generation",
        marketingSupport: "Marketing Support",
        operationsSupport: "Operations Support",
        learningDevelopment: "Learning & Development",
        industryExposure: "Industry Exposure",
      },
    },
    cart: {
      your_cart: "Your Cart",
      cart_tab: "Cart",
      summary_tab: "Summary",
      empty: "Your cart is empty",
      browse_equipment: "Browse Equipment",
      rental_type: "Rental Type",
      hourly: "Hourly",
      daily: "Daily",
      weekly: "Weekly",
      duration: "Duration",
      hours: "hours",
      days: "days",
      weeks: "weeks",
      dates: "Dates",
      save: "Save",
      order_summary: "Order Summary",
      subtotal: "Subtotal",
      tax: "Tax",
      total: "Total",
      continue_shopping: "Continue Shopping",
      proceed_to_checkout: "Proceed to Checkout",
      customer_info: "Customer Information",
      full_name: "Full Name",
      email: "Email",
      phone: "Phone Number",
      special_notes: "Special Notes",
      notes_placeholder: "Any special instructions or notes...",
      review_cart: "Review Cart",
      confirmation: "Confirmation",
      back: "Back",
      place_order: "Place Order",
    },
  },
  ar: {
    header: {
      title: "شركة المتحدة المحدودة",
      subtitle: "حلول المعدات الثقيلة",
      help: "تحتاج مساعدة؟",
      contact: "طلب اتصال",
      emergency: "حالة طارئة؟",
      login: "بوابة العميل",
      search: "ابحث عن معدات...",
      location: "المملكة العربية السعودية",
    },
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      services: "خدماتنا",
      equipment: "المعدات",
      projects: "مشاريعنا",
      ourteam: "فريقنا",
      developercrew: "طاقم المطورين",
      contact: "اتصل بنا",
      blog: "مدونة",
    },
    hero: {
      slide1: {
        subtitle: "مشروع مميز",
        title: "الشركة الرائدة في تأجير المعدات والمقاولات العامة",
        description:
          "نعمل بأسطول من معدات البناء الحديثة ونستثمر باستمرار في الحصول على الآليات الثقيلة المتطورة والصيانة الدقيقة لأصولنا الحالية. وهذا يضمن الأداء الأمثل والسلامة والموثوقية في جميع مشاريعنا",
        button: "عرض المشروع",
      },
      slide2: {
        subtitle: "نبني المستقبل",
        title: "الشركة الرائدة في تأجير المعدات والمقاولات العامة",
        description:
          "تسعى شركة المتحدة المحدودة إلى توسيع أعمالها ومجموعة معداتها الثقيلة بما يتماشى مع متطلبات سوق البناء والنفط والغاز والصناعة. يركز عملنا الأساسي على دعم عملائنا خلال العمليات الحرجة مثل إيقاف المصانع وخدمات الصيانة.",
        button: "عرض المشروع",
      },
      slide3: {
        subtitle: "خدماتنا",
        title: "الشركة الرائدة في تأجير المعدات والمقاولات العامة",
        description:
          "نعمل بأسطول من معدات البناء الحديثة ونستثمر باستمرار في الحصول على الآليات الثقيلة المتطورة والصيانة الدقيقة لأصولنا الحالية. وهذا يضمن الأداء الأمثل والسلامة والموثوقية في جميع مشاريعنا",
        button: "عرض المشروع",
      },
    },
    about: {
      firstpicturetag: "أفضل خدمات التأجير",
      secondpicturetag: "أفضل خدمات المقاولات",

      commonsection: "شركة رائدة في تأجير المعدات والمقاولات العامة",

      subtitle: "تعرف على شركة المتحدة المحدودة",
      title: "تأجير المعدات والمقاولات العامة",
      aboutpagetitle:
        "في شركة المتحدة المحدودة، نقدم حلولاً شاملة في مجالي تأجير المعدات والمقاولات العامة في المملكة العربية السعودية",

      description:
        "تأسست شركة المتحدة المحدودة في عام 2024، وهي شركة رائدة في خدمات التأجير والمقاولات العامة في المملكة العربية السعودية. كفرع فخور لمجموعة المتحدة للمعدات المعروفة، تلتزم شركة المتحدة المحدودة بقيادة قطاع تأجير المعدات والبناء والمقاولات في جميع الصناعات الرئيسية، بما في ذلك قطاعات النفط والغاز والبنية التحتية والصناعية المتطلبة.",

      seconddescription:
        "تكمن قوتنا في فريق ذو مهارات عالية من المهندسين المحترفين المكرسين لتقديم التميز في خدمات البناء وتأجير المعدات الثقيلة والمقاولات العامة. نحن نلتزم بأعلى معايير الجودة والسلامة والنزاهة والاستجابة، مع تعزيز شراكات قوية وطويلة الأمد مع عملائنا. تلتزم شركة المتحدة المحدودة بتكريس كل مشاركة والاستمرار في تقديم خدمات متميزة في قطاعات البناء والنفط والغاز والبنية التحتية والصناعية في جميع أنحاء المملكة العربية السعودية.",

      feature1: "خطط تأجير مرنة",
      feature2: "مشغلين ذوي خبرة ومهارة",
      feature3: "مرخص ومعتمد",
      feature4: "آلات موثوقة ومصانة جيداً",
      feature11: "وقت پر آلات کی ترسیل",
feature12: "قلیل مدتی اور طویل مدتی کرایہ",
feature13: "ماہر اور لائسنس یافتہ ٹیکنیشنز",
feature14: "جدید اور اچھی طرح سے دیکھ بھال شدہ فلیٹ",

      experience: "سنوات الخبرة",
      imageAlt:
        "حفارة للتأجير في السعودية - خدمات تأجير المعدات الثقيلة من شركة المتحدة المحدودة",
    },
    services: {
      title: "ہماری خدمات",
      subtitle: "آپ کے کاروباری تقاضوں کے لیے خصوصی حل",
      rental: {
        title: "کرایہ پر خدمات",
        desc: "یونائیٹڈ لمیٹڈ کمپنی تعمیراتی مشینری، صنعتی اوزار اور بھاری آلات کے لیے قابلِ اعتماد اور کم لاگت کرایہ پر خدمات فراہم کرتی ہے تاکہ آپ کے منصوبے مؤثر اور آسانی کے ساتھ مکمل ہوں۔ تعمیراتی آلات، صنعتی مشینری، خصوصی اوزار یا جدید کرایہ پر سہولتیں ہوں، ہم اچھی طرح سے دیکھ بھال کیے گئے، فوری استعمال کے قابل آلات فراہم کرتے ہیں جو آپ کے وقت اور بجٹ کے مطابق ہوں۔ لچکدار کرایہ کی شرائط، تصدیق شدہ آپریٹرز اور وقف شدہ کسٹمر سپورٹ کے ساتھ، یونائیٹڈ لمیٹڈ کمپنی سعودی عرب میں کرایہ پر خدمات کے لیے آپ کا قابلِ اعتماد ساتھی ہے۔",
      },
      contracting: {
        title: "جنرل کنٹریکٹنگ خدمات",
        desc: "یونائیٹڈ لمیٹڈ کمپنی کنٹریکٹنگ اور تعمیراتی خدمات میں ایک معتبر نام ہے، جو مختلف شعبوں میں اعلیٰ معیار کی سول انجینئرنگ، انفراسٹرکچر ڈیولپمنٹ اور مینٹیننس سلوشنز فراہم کرتی ہے۔ حفاظت، جدت، پائیداری اور بہترین معیار کے عزم کے ساتھ، ہم مشکل منصوبوں کو کامیابی میں بدلنے پر فخر کرتے ہیں۔ چاہے رہائشی تعمیرات ہوں، تجارتی کنٹریکٹنگ یا صنعتی منصوبے، یونائیٹڈ لمیٹڈ کمپنی سعودی عرب میں پائیدار نتائج کے لیے آپ کا قابلِ بھروسہ پارٹنر ہے۔",
      },
      learnMore: "مزید جانیں",
    },

    testimonials: {
      subtitle: "تعليقات العملاء",
      title: "ما يقوله عملاؤنا",
      quote1:
        "كانت الخدمة رائعة حقًا! لقد تجاوزوا توقعاتنا لتلبية احتياجاتنا وقدموا نتائج استثنائية. أوصي بهم بشدة لأي شخص يبحث عن خدمة عالية الجودة.",
      role1: "الرئيس التنفيذي، شركة أميكو",
    },
    projects: {
      title: "خبرتنا في تنفيذ المشاريع في جميع أنحاء المملكة العربية السعودية",
      subtitle: "مشاريعنا",
      description:
        "استعرض المشاريع الناجحة التي نفذتها شركة يونايتد المحدودة في مجالات النفط والغاز، والبناء، وإيقاف المصانع، وتطوير البنية التحتية في المملكة العربية السعودية.",
      servicesTitle: "الخدمات المقدمة",
      viewButton: "عرض المشروع",
      viewAllButton: "عرض جميع المشاريع",
      stats: {
        area: "المساحة (م²)",
        floors: "الطوابق",
        equipment: "المعدات المستخدمة",
        length: "الطول (كم)",
        lanes: "المسارات",
        buildings: "المباني",
      },
      services: {
        earthworks: "أعمال الحفر والتسوية",
        sitePrep: "تحضير المواقع",
        excavation: "خدمات الحفر",
        structural: "الإنشاءات الهيكلية",
        mep: "تركيب الميكانيكا والكهرباء",
        roadConstruction: "إنشاء الطرق",
        bridge: "أعمال الجسور",
        landscaping: "التنسيق الطبيعي",
        concrete: "أعمال الخرسانة",
        steel: "أعمال الحديد",
        utilities: "تركيب المرافق",
      },
      project1: {
        title: "مشروع مركز النقل جنوب غرب القدية",
        location: "القدية السفلى، الرياض، المملكة العربية السعودية",
        description:
          "تفخر شركة يونايتد المحدودة بقيادتها لمشروع إنشاء مركز النقل في القدية من خلال مشروع مركز النقل جنوب غرب الرياض، المملكة العربية السعودية. بصفتها واحدة من أبرز شركات المقاولات في الرياض المتخصصة في البنية التحتية، فإننا نتميز في المقاولات العامة لمشاريع النقل في جميع أنحاء المملكة. يوفر فريقنا الخبير الهندسة والكوادر الفنية في السعودية لضمان الدقة في جميع المراحل. كما ندعم العمليات من خلال تأجير معدات حديثة في الرياض، وأسطول مُعدّ لتلبية متطلبات البنية التحتية المكثفة. تُعد شركة يونايتد المحدودة اسمًا موثوقًا لتأجير المعدات في المملكة، مما يضمن تنفيذًا فعالًا عبر مختلف القطاعات. كما نقدم خدمات دعم المشاريع الاستراتيجية في السعودية، بما في ذلك المعدات المتخصصة لصناعة النفط والغاز ودعم المشاريع خلال فترات إيقاف المصانع.",
      },

      project2: {
        title: "مشروع QPAC",
        location: "القدية العليا، الرياض، المملكة العربية السعودية",
        description:
          "تفخر شركة يونايتد المحدودة بقيادتها لمشروع QPAC في القدية العليا، دعماً لأهداف تطوير البنية التحتية الوطنية في المملكة العربية السعودية. نحن متخصصون في البناء المتكامل في السعودية، وننفذ المشاريع المعقدة بأعلى درجات الدقة والامتثال. بصفتنا رواد في مشاريع البناء واسعة النطاق في الرياض، نوفر الدعم الفني الكامل للبنية التحتية ودعم المشاريع في الرياض. يبرز دورنا في مشروع QPAC حلولنا المخصصة في مجال البناء على مستوى المملكة. ومن خلال أسطول حديث، تضمن شركة يونايتد المحدودة تأجيرًا موثوقًا للمعدات في القدية وخدمات المعدات الثقيلة في جميع المراحل. ومعترف بنا كإحدى أبرز شركات المقاولات في القدية، نتماشى مع رؤية المملكة لتطوير البنية التحتية.",
      },

      project3: {
        title: "مشروع برج القدس",
        location: "الدوحة، قطر",
        description:
          "تفخر شركة يونايتد المحدودة بدعمها لمشروع برج القدس، والذي يُعد من المعالم البارزة في مجال الأبراج العالية في الدوحة ومنطقة الخليج. بصفتنا مقاولًا موثوقًا للمشاريع المتكاملة في قطر، نقود جميع مراحل هذا المشروع بدقة هيكلية وسرعة تنفيذ. نوفر كوادر فنية خبيرة في الدوحة وإدارة مشاريع متوافقة مع المعايير الإقليمية في جميع أنحاء الخليج. يشمل دورنا أيضًا خدمات تأجير المعدات المتقدمة في قطر، مما يضمن توفر آلات موثوقة وتشغيلًا ماهرًا في الموقع. تقدم شركة يونايتد المحدودة حلولًا مخصصة للبناء في قطر تفي بمتطلبات الأبراج العالية المعقدة. ونواصل دفع عجلة التنمية التجارية في الدوحة كاسم مفضل في مجال المقاولات التجارية.",
      },

      project4: {
        title: "مشروع أراضي الدوحة – مشيرب",
        location: "الدوحة، قطر",
        description:
          "تفخر شركة يونايتد المحدودة بمساهمتها في تطوير مشروع أراضي الدوحة – مشيرب، وهو أحد المعالم الرئيسية في قلب مدينة الدوحة. وقد تم اختيارنا لما نتمتع به من خبرة في مقاولات المشاريع متعددة الاستخدامات في قطر، حيث نقدم حلولًا مخصصة للمشاريع المعقدة على نطاق المدن. تشمل خدماتنا إدارة المشاريع المتقدمة وتوفير الكوادر الهندسية في مشيرب والدوحة، لضمان تنفيذ فعّال. كما نوفر معدات موثوقة ومشغلين مهرة للأعمال الحيوية في البنية التحتية والأعمال المدنية ضمن النطاق الحضري. وبصفتنا شريكًا موثوقًا للبناء المتكامل في قطر، تدعم شركة يونايتد المحدودة النمو المستدام في المنطقة. ويعزز دورنا في مجال المقاولات العقارية والبناء الحضري الاستراتيجي مكانتنا بين أفضل الشركات في الدوحة.",
      },
      project5: {
        title: "مشروع مواقف سيارات شيراتون",
        location: "الدوحة، قطر",
        description:
          "تقود شركة يونايتد المحدودة أعمال إنشاء مواقف السيارات في مشروع شيراتون بالدوحة، مما يعزز البنية التحتية الحضرية والتنقل. نحن نقدم أعمالًا مدنية متكاملة لمواقف السيارات المنظمة، مع خبرة في التصميم والتنفيذ ودمج الوصول العام. توفر شركة يونايتد المحدودة كوادر هندسية خبيرة وأنظمة حديثة لحلول مواقف موثوقة ومستدامة. مدعومين بأسطول متطور، نقدم تأجير معدات المشاريع المدنية وفقًا لأعلى معايير السلامة والأداء. يعزز دورنا في هذا المشروع بنية التنقل التحتية ويضع شركة يونايتد المحدودة بين أبرز شركات المقاولات في الدوحة للمشاريع العامة.",
      },
    },
    footerr: {
      contactUs: "ہم سے رابطہ کریں",
      company: {
        name: "یونائیٹڈ لمیٹڈ کمپنی",
        tagline: "کمپنی",
        description:
          "یونائیٹڈ لمیٹڈ کمپنی کا قیام 2024 میں ہوا۔ یہ سعودی عرب کی ایک نمایاں کرایہ پر خدمات اور جنرل کنٹریکٹنگ کمپنی ہے۔ مشہور یونائیٹڈ ایکوئپمنٹ گروپ کی ایک ذیلی کمپنی ہونے کے ناطے، یونائیٹڈ لمیٹڈ کمپنی تیل و گیس، انفراسٹرکچر اور صنعتی شعبوں سمیت تمام بڑے شعبوں میں کرایہ پر آلات، تعمیرات اور کنٹریکٹنگ کے شعبے میں قیادت کرنے کے لیے پرعزم ہے۔",
      },
      quickLinks: {
        title: "فوری روابط",
        about: "ہمارے بارے میں",
        privacy: "پرائیویسی پالیسی",
        carListing: "کار لسٹنگ",
        blog: "بلاگ",
        contact: "رابطہ",
      },
      contact: {
        title: "ہیڈ آفس",
        address:
          "8074، الصحابہ اسٹریٹ، الیَرمُک ڈسٹرکٹ، ریاض، 13243، مملکت سعودی عرب",
        phone: "+966538077541",
        email: "Ksa@unitedlimited.net",
        hours: "دفتر کے اوقات: صبح 8 بجے سے رات 10 بجے تک",
      },
      newsletter: {
        title: "نیوز لیٹر",
        description: "خصوصی پیشکشوں اور اپڈیٹس کے لیے سبسکرائب کریں",
        placeholder: "آپ کا ای میل",
      },
      privacy: "پرائیویسی پالیسی",
      paymentMethods: "ادائیگی کے طریقے",

      copyright: "کاپی رائٹ 2025، یونائیٹڈ لمیٹڈ کمپنی۔ تمام حقوق محفوظ ہیں",
      developedBy: "تیاری کردہ: اے آئی ٹیک کریو", // نیا اضافہ
      terms: "شرائط و ضوابط",
    },

    login: {
      welcome: "مرحبًا بكم في المتحدة المحدودة",
      tagline: "بوابة إدارة المعدات الثقيلة والبناء",
      feature1: "إدارة المشاريع",
      feature2: "تتبع المعدات",
      feature3: "تعاون الفريق",
      sign_in: "تسجيل الدخول",
      access_portal: "الوصول إلى بوابة إدارة البناء الخاصة بك",
      email: "عنوان البريد الإلكتروني",
      email_placeholder: "أدخل بريدك الإلكتروني للشركة",
      password: "كلمة المرور",
      password_placeholder: "أدخل كلمة المرور الخاصة بك",
      forgot_password: "نسيت كلمة المرور؟",
      signing_in: "جاري تسجيل الدخول...",
      no_account: "ليس لديك حساب؟",
      contact_admin: "اتصل بمسؤولك",
      error: "بيانات الاعتماد غير صالحة. يرجى المحاولة مرة أخرى.",
      network_error: "خطأ في الشبكة. يرجى المحاولة مرة أخرى لاحقًا.",
    },
    footer: {
      company: {
        name: "المتحدة المحدودة",
        tagline: "شركة",
      },
      quickLinks: {
        privacy: "سياسة الخصوصية",
        contact: "اتصل بنا",
      },
      copyright: "حقوق النشر 2025، شركة المتحدة المحدودة. جميع الحقوق محفوظة",
      terms: "الشروط والأحكام",
    },
    contact: {
      contact: "تواصل معنا | شركة يونايتد المحدودة - المملكة العربية السعودية",

      sectionTitle: "تواصل معنا",
      sectionSubtitle: "تواصل مع شركة يونايتد المحدودة",
      contactdescription:
        "تواصل مع شركة يونايتد المحدودة للحصول على خدمات تأجير المعدات والمقاولات في المملكة العربية السعودية. احصل على الدعم لمشاريع النفط والغاز، والبناء، والبنية التحتية.",

      formTitle: "أرسل لنا رسالة",
      namePlaceholder: "اسمك",
      emailPlaceholder: "البريد الإلكتروني",
      phonePlaceholder: "رقم الهاتف",
      messagePlaceholder: "رسالتك...",
      sendButton: "إرسال الرسالة",
      infoTitle: "معلومات التواصل",
      infoSubtitle: "يمكنك التواصل معنا عبر أي من هذه القنوات",
      locationTitle: "موقعنا",
      phoneTitle: "رقم الهاتف",
      emailTitle: "البريد الإلكتروني",
      hoursTitle: "ساعات العمل",
      supportText: "الدعم الفني",
      weekdaysHours: "السبت - الخميس: 7 صباحًا - 5 مساءً",

      weekendHours: "الجمعة - السبت: 10 صباحًا - 6 مساءً",
      followUs: "تابعنا",
    },
    team: {
      title:
        "فريق الهندسة والمشاريع لدينا | شركة يونايتد المحدودة - المملكة العربية السعودية",

      subtitle: "فريق مُعدّ للأداء العالي",
      description:
        "تعرّف على المهندسين المحترفين والمتخصصين في شركة يونايتد المحدودة الذين يقدمون خدمات تأجير ومقاولات متميزة في المملكة العربية السعودية.",

      expertiseTitle: "المهارات الرئيسية",
      members: {
        samir: {
          name: "المهندس سمير المغني",
          position: "المدير التنفيذي",
        },
        ali: {
          name: "علي اسفند",
          position: "الرئيس التنفيذي",
        },
        muhammad: {
          name: "محمد عبد الله",
          position: "مدير التسويق",
        },
      },
      bio: {
        managingDirector:
          "مهندس مخضرم مع أكثر من 20 سنة في قيادة المشاريع الإنشائية...",
        ceo: "قائد أعمال استراتيجي يركز على النمو والابتكار...",
        cmo: "خبير تسويق بسجل حافل في الحملات الناجحة...",
      },
      expertise: {
        strategy: "التخطيط الاستراتيجي",
        leadership: "القيادة التنفيذية",
        engineering: "التميز الهندسي",
        operations: "إدارة العمليات",
        management: "إدارة الأعمال",
        finance: "الإستراتيجية المالية",
        growth: "تطوير النمو",
        innovation: "الابتكار",
        branding: "إستراتيجية العلامة التجارية",
        digital: "التسويق الرقمي",
        communications: "الاتصالات المؤسسية",
      },
    },
    developerCrew: {
      developerCrewContent:
        "في شركة يونايتد المحدودة، يتحمل فريق المطورين مسؤولية نمو الأعمال، وكفاءة العمليات، وتوسيع محفظة الخدمات في مجالي تأجير المعدات والمقاولات.",

      title: "فريق المطورين",
      subtitle: "الابتكار وراء نمونا التشغيلي",

      description:
        "يقود فريق المطورين في شركة يونايتد المحدودة نمو الأعمال وتوسّع المعدات لتحقيق النجاح في مجالي التأجير والمقاولات في جميع أنحاء المملكة العربية السعودية.",

      roleSummaryTitle: "ملخص الدور",
      expertiseTitle: "المهارات الأساسية",
      members: {
        muhammad: {
          name: "محمد عبد الله",
          position: "مدير العمليات والمشاريع",
        },
        sohaib: {
          name: "سهيب سليم",
          position: "المطور (قائد فني)",
        },
        raza: {
          name: "رضا علي",
          position: "تنفيذي التسويق الرقمي",
        },
        intern: {
          name: "أيلا علي خان (متدربة)",
          position: "دعم التسويق والعمليات",
        },
      },
      roles: {
        muhammad:
          "محترف ذو مهارات عالية مع 6 سنوات من الخبرة في العمليات وعلاقات العملاء وإدارة المشاريع عبر الشركات متعددة الجنسيات. كمدير عمليات ومشاريع في AI Tech Crew، يقود محمد عبد الله الفريق لتقديم حلول تكنولوجيا المعلومات عالية الجودة مع ضمان سير العمل بسلاسة وتجارب عملاء ممتازة. معتمد من جوجل في التسويق الرقمي وإدارة المشاريع، يجمع بين التفكير الاستراتيجي والخبرة العملية لنمو الشركة ودفع نجاح مشاريع العملاء.",
        sohaib:
          "مطور ذو مهارات عالية مع 4 سنوات من الخبرة المهنية في تطوير الويب والبرمجيات. كقائد فني في AI Tech Crew، فهو مسؤول عن تصميم وتطوير وتنفيذ حلول تكنولوجيا المعلومات المبتكرة التي تلبي احتياجات العملاء ومعايير الصناعة.",
        raza: "تنفيذي تسويق رقمي موجه نحو النتائج مع 3 سنوات من الخبرة في إنشاء وتنفيذ حملات تسويقية ناجحة. في AI Tech Crew، فهو مسؤول عن بناء الوجود الرقمي للشركة، وإدارة حملات العملاء، وقيادة العملاء المحتملين لنمو الأعمال.",
        intern:
          "دور تعليمي مصمم لدعم فرق التسويق والعمليات وإدارة المشاريع. سيساعد المتدرب في المهام اليومية، واكتساب خبرة عملية في صناعة خدمات تكنولوجيا المعلومات، وتطوير المهارات المهنية في التسويق الرقمي وعمليات الأعمال.",
      },
      expertise: {
        operations: "إدارة العمليات",
        projectManagement: "إدارة المشاريع",
        clientRelations: "علاقات العملاء",
        digitalMarketing: "التسويق الرقمي",
        webDevelopment: "تطوير الويب",
        softwareDevelopment: "تطوير البرمجيات",
        technicalLeadership: "القيادة الفنية",
        innovation: "الابتكار",
        campaignManagement: "إدارة الحملات",
        brandBuilding: "بناء العلامة التجارية",
        leadGeneration: "توليد العملاء المحتملين",
        marketingSupport: "دعم التسويق",
        operationsSupport: "دعم العمليات",
        learningDevelopment: "التعلم والتطوير",
        industryExposure: "التعرض للصناعة",
      },
    },
    cart: {
      your_cart: "سلة التسوق",
      cart_tab: "السلة",
      summary_tab: "ملخص",
      empty: "سلة التسوق فارغة",
      browse_equipment: "تصفح المعدات",
      rental_type: "نوع التأجير",
      hourly: "ساعي",
      daily: "يومي",
      weekly: "أسبوعي",
      duration: "المدة",
      hours: "ساعات",
      days: "أيام",
      weeks: "أسابيع",
      dates: "التواريخ",
      save: "وفر",
      order_summary: "ملخص الطلب",
      subtotal: "المجموع الجزئي",
      tax: "الضريبة",
      total: "الإجمالي",
      continue_shopping: "مواصلة التسوق",
      proceed_to_checkout: "إتمام الشراء",
      customer_info: "معلومات العميل",
      full_name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "رقم الهاتف",
      special_notes: "ملاحظات خاصة",
      notes_placeholder: "أي تعليمات أو ملاحظات خاصة...",
      review_cart: "مراجعة السلة",
      confirmation: "تأكيد",
      back: "رجوع",
      place_order: "تأكيد الطلب",
    },
  },
};

export const useTranslation = () => {
  const { language } = useContext(LanguageContext);

  return (key) => {
    const keys = key.split(".");
    return keys.reduce((obj, k) => obj?.[k], translations[language]) || key;
  };
};
